package com.example.monetix.ui.components

import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.padding
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.TextUnit
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import kotlin.math.abs

@Composable
fun ModernMoneyText(
    cents: Long,
    hideBalances: Boolean = false,
    sign: String = "",
    color: Color = MaterialTheme.colorScheme.onSurface,
    integerFontSize: TextUnit = 24.sp,
    decimalFontSize: TextUnit = 14.sp,
    symbolFontSize: TextUnit = 14.sp,
    modifier: Modifier = Modifier
) {
    if (hideBalances) {
        Text(
            text = "•••• €",
            style = MaterialTheme.typography.titleLarge.copy(
                fontWeight = FontWeight.Black,
                fontSize = integerFontSize
            ),
            color = color,
            modifier = modifier
        )
    } else {
        val absoluteCents = abs(cents)
        val euros = absoluteCents / 100
        val decimals = (absoluteCents % 100).toString().padStart(2, '0')
        val displaySign = if (sign.isNotEmpty()) sign else if (cents < 0) "-" else ""

        // Algoritmo cross-platform per il punto delle migliaia
        val formattedEuros = euros.toString().reversed().chunked(3).joinToString(".").reversed()

        Row(verticalAlignment = Alignment.Bottom, modifier = modifier) {
            if (displaySign.isNotEmpty()) {
                Text(
                    text = "$displaySign ",
                    style = MaterialTheme.typography.bodyMedium.copy(fontWeight = FontWeight.Bold, fontSize = symbolFontSize),
                    color = color,
                    modifier = Modifier.padding(bottom = 2.dp)
                )
            }
            Text(
                text = "€ ",
                style = MaterialTheme.typography.bodyMedium.copy(fontWeight = FontWeight.Bold, fontSize = symbolFontSize),
                color = color.copy(alpha = 0.7f), // Stesso colore, ma leggermente più delicato
                modifier = Modifier.padding(bottom = 2.dp)
            )
            Text(
                text = formattedEuros,
                style = MaterialTheme.typography.titleLarge.copy(fontWeight = FontWeight.Black, fontSize = integerFontSize, letterSpacing = (-0.5).sp),
                color = color
            )
            Text(
                text = ",$decimals",
                style = MaterialTheme.typography.bodyMedium.copy(fontWeight = FontWeight.Bold, fontSize = decimalFontSize),
                color = color, // 🚀 ORA I CENTESIMI HANNO LO STESSO COLORE DEI NUMERI INTERI
                modifier = Modifier.padding(bottom = 3.dp)
            )
        }
    }
}